import { NgModule } from '@angular/core';
import { NavigationEnd, Router, RouterModule, Routes } from '@angular/router';
import { AutoLoginAllRoutesGuard } from 'angular-auth-oidc-client';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { AdminComponent } from './components/admin/admin.component';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { HomeComponent } from './components/home/home.component';
import { ProcessingComponent } from './components/processing/processing.component';
import { ProtectedComponent } from './components/protected/protected.component';
import { SyncComponent } from './components/sync/sync.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { AuthAdminGuard } from './core/auth/auth-admin.guard';

const appRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'sync', component: SyncComponent, canActivate: [AutoLoginAllRoutesGuard] },
  { path: 'home', component: HomeComponent, canActivate: [AutoLoginAllRoutesGuard] },
  { path: 'protected', component: ProtectedComponent, canActivate: [AutoLoginAllRoutesGuard] },
  { path: 'forbidden', component: ForbiddenComponent, canActivate: [AutoLoginAllRoutesGuard] },
  { path: 'admin', component: AdminComponent, canActivate: [AutoLoginAllRoutesGuard, AuthAdminGuard] },
  {
    path: 'processing',
    //loadChildren: () => import('./components/processing/processing.module').then((m) => m.ProcessingModule),
    //canLoad: [AutoLoginAllRoutesGuard],
    component: ProcessingComponent,
    canActivate: [AutoLoginAllRoutesGuard]
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private router: Router) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        //On every route change
      }
    });
  }
  
}
